import { createSelector } from 'reselect'

const getBindersEntity = (state, props) => state.binders.entities[props.entityUID]

const binders_save_form_metrics = createSelector(
	[ getBindersEntity ],
	bindersEntity => ({
		'Sub Plan Name': bindersEntity.form_data.name,
		'Start Absence': new Date(bindersEntity.form_data.absence_date_from).toISOString(),
		'Finish Absence': new Date(bindersEntity.form_data.absence_date_to).toISOString(),
		'Number of Lessons': bindersEntity.count_lessons,
	})
)

export default binders_save_form_metrics
